var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.showType === '1')?_c('div',{staticClass:"handsel-order-detail-time",domProps:{"innerHTML":_vm._s(_vm.times)}}):_c('div',{staticClass:"time-down"},[_vm._v(" 请在 "),_c('span',[_vm._v(_vm._s(_vm.times))]),_vm._v("内完成"+_vm._s(_vm.showTitle(_vm.handselInfo.status))+"支付，超时将自动"+_vm._s(_vm.handselInfo.status===1?'取消':'关闭')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }